<template>
  <div class="elite-tabs-wrapper-content">
    <div class="row">
      <div class="col-9">
        <dl class="row" v-if="$currentUserCan($permissions.PERM_VIEW_ANY_USERS)">
          <dt class="col-sm-4">{{ $t("COMMON.USER") }}</dt>
          <dd class="col-sm-8">
            <user :user="blackListUser.user" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd class="col-sm-8">
            <organization :organization="blackListUser.organization" />
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.EXCERPT") }}</dt>
          <dd class="col-sm-8">
            <div v-html="blackListUser.excerpt"></div>
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="blackListUser.created_at">
            {{ $formatDate(blackListUser.created_at) }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="blackListUser.updated_at">
            {{ $formatDate(blackListUser.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>

import User from "@/components/User.vue";
import blackListUsers from "../../../../../i18n/fr/blackListUsers";
export default {
  name: "black-list-user-view-global",

  components: {
    User
  },

  props: ["blackListUser"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    blackListUser(blackListUser) {},
  },
};
</script>
